export const AD_CREATIVE = {
  page: 'ad-creative-lab-page',
  refresh: 'ad-creative-refresh-catalog',
  plan: 'ad-creative-plan',
  generate: 'ad-creative-generate',
  runFullPath: 'ad-creative-run-full-path',
  tabs: 'ad-creative-tabs',
  tab: (id: string) => `ad-creative-tab-${id}`,
  workspaceSummary: 'ad-creative-workspace-summary',
  createCampaign: 'ad-creative-create-campaign',
  campaignList: 'ad-creative-campaign-list',
  campaignCard: (id: string) => `ad-creative-campaign-card-${id}`,
  campaignName: 'ad-creative-campaign-name',
  platformList: 'ad-creative-platform-list',
  platformCard: (id: string) => `ad-creative-platform-card-${id}`,
  platformWorkspace: 'ad-creative-platform-workspace',
  platformWorkspaceTabs: 'ad-creative-platform-workspace-tabs',
  platformWorkspaceTab: (id: string) => `ad-creative-platform-workspace-tab-${id}`,
  platformDesignPackageSummary: 'ad-creative-platform-design-package-summary',
  platformDesignSlotMatrix: 'ad-creative-platform-design-slot-matrix',
  platformDesignSlot: (id: string) => `ad-creative-platform-design-slot-${id}`,
  briefList: 'ad-creative-brief-list',
  briefCard: (id: string) => `ad-creative-brief-card-${id}`,
  briefBulkDelete: 'ad-creative-brief-bulk-delete',
  generateBriefTopics: 'ad-creative-generate-brief-topics',
  generateBriefTopicsDialog: 'ad-creative-generate-brief-topics-dialog',
  generateBriefTopicsAudience: 'ad-creative-generate-brief-topics-audience',
  generateBriefTopicsTask: 'ad-creative-generate-brief-topics-task',
  generateBriefTopicsSubmit: 'ad-creative-generate-brief-topics-submit',
  briefGenerationHistory: 'ad-creative-brief-generation-history',
  briefGenerationHistoryDialog: 'ad-creative-brief-generation-history-dialog',
  addBriefManually: 'ad-creative-add-brief-manually',
  selectedBriefWorkspace: 'ad-creative-selected-brief-workspace',
  briefDetailBack: 'ad-creative-brief-detail-back',
  briefDetailTabs: 'ad-creative-brief-detail-tabs',
  briefDetailTab: (id: string) => `ad-creative-brief-detail-tab-${id}`,
  selectedBriefResearch: 'ad-creative-selected-brief-research',
  selectedBriefAngles: 'ad-creative-selected-brief-angles',
  selectedBriefGenerateCreatives: 'ad-creative-selected-brief-generate-creatives',
  sourcePicker: 'ad-creative-source-picker',
  sourceOption: (id: string) => `ad-creative-source-option-${id}`,
  runResearch: 'ad-creative-run-research',
  angleList: 'ad-creative-angle-list',
  designList: 'ad-creative-design-list',
  designCard: (id: string) => `ad-creative-design-card-${id}`,
  assetSwitch: 'ad-creative-asset-switch',
  collectionList: 'ad-creative-collection-list',
  collection: (id: string) => `ad-creative-collection-${id}`,
  designCollectionWorkspace: 'ad-creative-design-collection-workspace',
  designCollectionDetailTabs: 'ad-creative-design-collection-detail-tabs',
  designCollectionDetailTab: (id: string) => `ad-creative-design-collection-detail-tab-${id}`,
  newDesignCollection: 'ad-creative-new-design-collection',
  generateDesignCollection: 'ad-creative-generate-design-collection',
  generateDesignCollectionDialog: 'ad-creative-generate-design-collection-dialog',
  generateDesignCollectionSubmit: 'ad-creative-generate-design-collection-submit',
  saveDesignCollection: 'ad-creative-save-design-collection',
  designSettings: 'ad-creative-design-settings',
  designCollectionName: 'ad-creative-design-collection-name',
  designCollectionPalette: 'ad-creative-design-collection-palette',
  designCollectionTypography: 'ad-creative-design-collection-typography',
  designCollectionComposition: 'ad-creative-design-collection-composition',
  designCollectionCurrent: 'ad-creative-design-collection-current',
  designPresetEnabled: (id: string) => `ad-creative-design-preset-enabled-${id}`,
  designPresetSlotLimit: (id: string) => `ad-creative-design-preset-slot-limit-${id}`,
  presetCard: (id: string) => `ad-creative-preset-card-${id}`,
  creativeTypePresetDialog: 'ad-creative-creative-type-preset-dialog',
  creativeTypePresetTabs: 'ad-creative-creative-type-preset-tabs',
  creativeTypePresetTab: (id: string) => `ad-creative-creative-type-preset-tab-${id}`,
  templateGallery: 'ad-creative-template-gallery',
  templatePreview: (id: string) => `ad-creative-template-preview-${id}`,
  template: (id: string) => `ad-creative-template-${id}`,
  styleSelect: 'ad-creative-style-select',
  item: (id: string) => `ad-creative-item-${id}`,
  image: (id: string) => `ad-creative-image-${id}`,
  open: (id: string) => `ad-creative-open-${id}`,
  validate: (id: string) => `ad-creative-validate-${id}`,
  export: (id: string) => `ad-creative-export-${id}`,
  createLaunchPlan: 'ad-creative-create-launch-plan',
  exportLaunchPlan: 'ad-creative-export-launch-plan',
  importMetrics: 'ad-creative-import-metrics',
  improveCampaign: 'ad-creative-improve-campaign',
  taskTrail: 'ad-creative-task-trail',
  taskTrailEntry: (id: string) => `ad-creative-task-trail-entry-${id}`,
  status: 'ad-creative-generation-status',
  dailyWorkflow: 'ad-creative-daily-workflow',
  dailyProgress: 'ad-creative-daily-progress',
  dailyStartNext: 'ad-creative-daily-start-next',
  dailyDraftFive: 'ad-creative-daily-draft-five',
  dailyCampaign: (id: string) => `ad-creative-daily-campaign-${id}`,
  list: 'ad-creative-list',
  detailDialog: 'ad-creative-detail-dialog',
  detailImage: 'ad-creative-detail-image',
  detailSettings: 'ad-creative-detail-settings',
  detailAssetPrompt: 'ad-creative-detail-asset-prompt',
  detailCopy: 'ad-creative-detail-copy',
  detailHeadline: 'ad-creative-detail-headline',
  detailPrimary: 'ad-creative-detail-primary',
  detailDescription: 'ad-creative-detail-description',
  detailCta: 'ad-creative-detail-cta',
  detailDestinationUrl: 'ad-creative-detail-destination-url',
  detailSave: 'ad-creative-detail-save',
  detailClose: 'ad-creative-detail-close',
  metaDraftPanel: 'ad-creative-meta-draft-panel',
  metaDraftConnect: 'ad-creative-meta-draft-connect',
  metaDraftDisconnect: 'ad-creative-meta-draft-disconnect',
  metaDraftRefresh: 'ad-creative-meta-draft-refresh',
  metaDraftAdAccount: 'ad-creative-meta-draft-ad-account',
  metaDraftPage: 'ad-creative-meta-draft-page',
  metaDraftCampaign: 'ad-creative-meta-draft-campaign',
  metaDraftAdSet: 'ad-creative-meta-draft-ad-set',
  metaDraftLinkUrl: 'ad-creative-meta-draft-link-url',
  metaDraftCreate: 'ad-creative-meta-draft-create',
  metaDraftCheckStatus: 'ad-creative-meta-draft-check-status',
  metaDraftResult: 'ad-creative-meta-draft-result',
  videoSection: 'ad-creative-video-section',
  videoModel: 'ad-creative-video-model',
  videoDuration: 'ad-creative-video-duration',
  videoGenerate: 'ad-creative-video-generate',
  videoTranscriptGenerate: 'ad-creative-video-transcript-generate',
  videoTranscriptCancel: 'ad-creative-video-transcript-cancel',
  videoTranscriptCheckProgress: 'ad-creative-video-transcript-check-progress',
  videoCostCaption: 'ad-creative-video-cost-caption',
  videoSegmentChip: (index: number) => `ad-creative-video-segment-chip-${index}`,
  videoPlayer: 'ad-creative-video-player',
  videoDurationBadge: 'ad-creative-video-duration-badge',
  videoValidationChip: (id: string) => `ad-creative-video-validation-${id}`,
  videoRegenerate: 'ad-creative-video-regenerate',
  videoRegenerateOption: (mode: string) => `ad-creative-video-regenerate-${mode}`,
  videoError: 'ad-creative-video-error',
} as const;

/** Review-first Creative Decisions -> Ad Creative refresh handoff. */
export const AD_CREATIVE_REFRESH_HANDOFF = {
  page: 'ad-creative-refresh-handoff-page',
  back: 'ad-creative-refresh-handoff-back',
  invalid: 'ad-creative-refresh-handoff-invalid',
  unavailable: 'ad-creative-refresh-handoff-unavailable',
  sourceSummary: 'ad-creative-refresh-handoff-source-summary',
  lineage: 'ad-creative-refresh-handoff-lineage',
  noProviderMutation: 'ad-creative-refresh-handoff-no-provider-mutation',
  variation: (id: string) => `ad-creative-refresh-handoff-variation-${id}`,
  mde: 'ad-creative-refresh-handoff-mde',
  minimumDuration: 'ad-creative-refresh-handoff-minimum-duration',
  stoppingPolicy: 'ad-creative-refresh-handoff-stopping-policy',
  protocol: 'ad-creative-refresh-handoff-protocol',
  submit: 'ad-creative-refresh-handoff-submit',
  error: 'ad-creative-refresh-handoff-error',
  completed: 'ad-creative-refresh-handoff-completed',
  openCompleted: 'ad-creative-refresh-handoff-open-completed',
} as const;

/** Phase Zero read-only provider source sync and exact-snapshot handoff. */
export const AD_CREATIVE_PROVIDER_SOURCES = {
  page: 'ad-creative-provider-sources-page',
  back: 'ad-creative-provider-sources-back',
  truthNotice: 'ad-creative-provider-sources-truth-notice',
  account: 'ad-creative-provider-sources-account',
  allCurrentScope: 'ad-creative-provider-sources-all-current-scope',
  accountScope: 'ad-creative-provider-sources-account-scope',
  accountScopeCheckbox: (id: string) => `ad-creative-provider-sources-account-scope-${id}`,
  campaignList: 'ad-creative-provider-sources-campaign-list',
  campaignLoadMore: 'ad-creative-provider-sources-campaign-load-more',
  campaign: (id: string) => `ad-creative-provider-sources-campaign-${id}`,
  campaignCheckbox: (id: string) => `ad-creative-provider-sources-campaign-check-${id}`,
  mirrorMedia: 'ad-creative-provider-sources-mirror-media',
  onlySegmentlyAssociated: 'ad-creative-provider-sources-only-segmently-associated',
  associationFrom: 'ad-creative-provider-sources-association-from',
  associationTo: 'ad-creative-provider-sources-association-to',
  mediaScope: 'ad-creative-provider-sources-media-scope',
  preflight: 'ad-creative-provider-sources-preflight',
  preflightResult: 'ad-creative-provider-sources-preflight-result',
  preflightInspectedAds: 'ad-creative-provider-sources-preflight-inspected-ads',
  preflightIncludedBindings: 'ad-creative-provider-sources-preflight-included-bindings',
  preflightIncludedUniqueCreatives: 'ad-creative-provider-sources-preflight-included-unique-creatives',
  preflightNotLinked: 'ad-creative-provider-sources-preflight-not-linked',
  preflightUnknown: 'ad-creative-provider-sources-preflight-unknown',
  preflightCampaign: (campaignId: string) => `ad-creative-provider-sources-preflight-campaign-${campaignId}`,
  preflightExpiry: 'ad-creative-provider-sources-preflight-expiry',
  preflightWarning: (code: string) => `ad-creative-provider-sources-preflight-warning-${code}`,
  preflightEmptySelectedScope: 'ad-creative-provider-sources-preflight-empty-selected-scope',
  includeAllSelectedAds: 'ad-creative-provider-sources-include-all-selected-ads',
  confirmation: 'ad-creative-provider-sources-confirmation',
  sync: 'ad-creative-provider-sources-sync',
  syncResult: 'ad-creative-provider-sources-sync-result',
  syncCancel: 'ad-creative-provider-sources-sync-cancel',
  syncResume: 'ad-creative-provider-sources-sync-resume',
  candidateQueue: 'ad-creative-provider-source-candidate-queue',
  candidate: (id: string) => `ad-creative-provider-source-candidate-${id}`,
  candidateCheckbox: (id: string) => `ad-creative-provider-source-candidate-check-${id}`,
  candidateLoadMore: 'ad-creative-provider-source-candidate-load-more',
  candidatePreflight: 'ad-creative-provider-source-candidate-preflight',
  candidatePreflightResult: 'ad-creative-provider-source-candidate-preflight-result',
  candidateConfirmation: 'ad-creative-provider-source-candidate-confirmation',
  candidateSync: 'ad-creative-provider-source-candidate-sync',
  sourceList: 'ad-creative-provider-sources-list',
  sourceLoadMore: 'ad-creative-provider-sources-load-more',
  sourceCard: (id: string) => `ad-creative-provider-source-${id}`,
  sourceCheckbox: (id: string) => `ad-creative-provider-source-taxonomy-check-${id}`,
  sourceOpen: (id: string) => `ad-creative-provider-source-open-${id}`,
  taxonomyPreflight: 'ad-creative-provider-source-taxonomy-preflight',
  taxonomyPreflightResult: 'ad-creative-provider-source-taxonomy-preflight-result',
  taxonomyConfirmation: 'ad-creative-provider-source-taxonomy-confirmation',
  taxonomyStart: 'ad-creative-provider-source-taxonomy-start',
  taxonomyTaskState: 'ad-creative-provider-source-taxonomy-task-state',
  taxonomyDetail: 'ad-creative-provider-source-taxonomy-detail',
  taxonomyApprove: 'ad-creative-provider-source-taxonomy-approve',
  taxonomyReject: 'ad-creative-provider-source-taxonomy-reject',
  detail: 'ad-creative-provider-source-detail',
  detailClose: 'ad-creative-provider-source-detail-close',
  mediaGallery: 'ad-creative-provider-source-media-gallery',
  mediaGalleryItem: (index: number) => `ad-creative-provider-source-media-gallery-item-${index}`,
  mediaGalleryUnavailable: (index: number) => `ad-creative-provider-source-media-gallery-unavailable-${index}`,
  languageState: 'ad-creative-provider-source-language-state',
  detectLanguage: 'ad-creative-provider-source-detect-language',
  languageDetectionPreflight: 'ad-creative-provider-source-language-detection-preflight',
  languageDetectionEstimate: 'ad-creative-provider-source-language-detection-estimate',
  languageDetectionConfirmation: 'ad-creative-provider-source-language-detection-confirmation',
  languageDetectionStart: 'ad-creative-provider-source-language-detection-start',
  languageDetectionState: 'ad-creative-provider-source-language-detection-state',
  languageDetectionAttention: 'ad-creative-provider-source-language-detection-attention',
  languageDetectionSuggestedLocale: (locale: string) => `ad-creative-provider-source-language-detection-suggested-${locale}`,
  languageDetectionError: 'ad-creative-provider-source-language-detection-error',
  sourceLocale: (locale: string) => `ad-creative-provider-source-locale-${locale}`,
  confirmLanguage: 'ad-creative-provider-source-confirm-language',
  deploymentContext: (bindingId: string) => `ad-creative-provider-source-deployment-context-${bindingId}`,
  baselineChoices: 'ad-creative-provider-source-baseline-choices',
  baselineChoice: (candidateId: string) => `ad-creative-provider-source-baseline-choice-${candidateId}`,
  baselineMedia: (candidateId: string, index: number) => `ad-creative-provider-source-baseline-media-${candidateId}-${index}`,
  selectBaseline: 'ad-creative-provider-source-select-baseline',
  baselineSelected: 'ad-creative-provider-source-baseline-selected',
  targetLocale: (locale: string) => `ad-creative-provider-source-target-${locale}`,
  createDraft: 'ad-creative-provider-source-create-draft',
  createdDraft: 'ad-creative-provider-source-created-draft',
} as const;

/** Exact-source human review used before on-screen video text localization. */
export const AD_CREATIVE_VIDEO_TEXT_INSPECTION = {
  panel: 'ad-creative-video-text-inspection',
  sourceVideo: 'ad-creative-video-text-inspection-source-video',
  history: 'ad-creative-video-text-inspection-history',
  useEvidence: (evidenceId: string) => `ad-creative-video-text-inspection-use-${evidenceId}`,
  loadMore: 'ad-creative-video-text-inspection-load-more',
  region: (regionId: string) => `ad-creative-video-text-inspection-region-${regionId}`,
  sourceText: (regionId: string) => `ad-creative-video-text-inspection-source-${regionId}`,
  targetText: (regionId: string) => `ad-creative-video-text-inspection-target-${regionId}`,
  startSeconds: (regionId: string) => `ad-creative-video-text-inspection-start-${regionId}`,
  endSeconds: (regionId: string) => `ad-creative-video-text-inspection-end-${regionId}`,
  leftPercent: (regionId: string) => `ad-creative-video-text-inspection-left-${regionId}`,
  topPercent: (regionId: string) => `ad-creative-video-text-inspection-top-${regionId}`,
  widthPercent: (regionId: string) => `ad-creative-video-text-inspection-width-${regionId}`,
  heightPercent: (regionId: string) => `ad-creative-video-text-inspection-height-${regionId}`,
  removeRegion: (regionId: string) => `ad-creative-video-text-inspection-remove-${regionId}`,
  addRegion: 'ad-creative-video-text-inspection-add-region',
  confirmation: 'ad-creative-video-text-inspection-confirmation',
  save: 'ad-creative-video-text-inspection-save',
  evidence: 'ad-creative-video-text-inspection-evidence',
  error: 'ad-creative-video-text-inspection-error',
} as const;

/** Human-reviewed selected scenes and protected references for cultural video adaptation. */
export const AD_CREATIVE_CULTURAL_VISUAL = {
  panel: 'ad-creative-cultural-visual',
  sourceVideo: 'ad-creative-cultural-visual-source-video',
  history: 'ad-creative-cultural-visual-history',
  useEvidence: (evidenceId: string) => `ad-creative-cultural-visual-use-${evidenceId}`,
  loadMore: 'ad-creative-cultural-visual-load-more',
  scene: (sceneId: string) => `ad-creative-cultural-visual-scene-${sceneId}`,
  startSeconds: (sceneId: string) => `ad-creative-cultural-visual-start-${sceneId}`,
  endSeconds: (sceneId: string) => `ad-creative-cultural-visual-end-${sceneId}`,
  instruction: (sceneId: string) => `ad-creative-cultural-visual-instruction-${sceneId}`,
  removeScene: (sceneId: string) => `ad-creative-cultural-visual-remove-${sceneId}`,
  addScene: 'ad-creative-cultural-visual-add-scene',
  reference: (slotKey: string) => `ad-creative-cultural-visual-reference-${slotKey}`,
  playbackConfirmation: 'ad-creative-cultural-visual-playback-confirmation',
  referencesConfirmation: 'ad-creative-cultural-visual-references-confirmation',
  save: 'ad-creative-cultural-visual-save',
  evidence: 'ad-creative-cultural-visual-evidence',
  error: 'ad-creative-cultural-visual-error',
} as const;

/** Read-only Funnel Insights -> exact Segmently rendition review handoff. */
export const AD_CREATIVE_LOCALIZED_VARIATION_HANDOFF = {
  banner: 'ad-creative-localized-variation-handoff',
  invalid: 'ad-creative-localized-variation-handoff-invalid',
  unavailable: 'ad-creative-localized-variation-handoff-unavailable',
  exactPins: 'ad-creative-localized-variation-handoff-exact-pins',
  noProviderMutation: 'ad-creative-localized-variation-handoff-no-provider-mutation',
  openSource: 'ad-creative-localized-variation-handoff-open-source',
  createChild: 'ad-creative-localized-variation-handoff-create-child',
  showAll: 'ad-creative-localized-variation-handoff-show-all',
  focusedCard: 'ad-creative-localized-variation-handoff-focused-card',
} as const;

/** Guided batch workspace (UX simplification plan §4.3–§4.9). */
export const AD_CREATIVE_BATCH = {
  workspace: 'ad-creative-batch-workspace',
  back: 'ad-creative-batch-back',
  title: 'ad-creative-batch-title',
  rail: 'ad-creative-batch-rail',
  railStep: (key: string) => `ad-creative-batch-rail-step-${key}`,
  briefSummary: 'ad-creative-batch-brief-summary',
  editBrief: 'ad-creative-batch-edit-brief',
  moreVariants: 'ad-creative-batch-more-variants',
  continueToLaunch: 'ad-creative-batch-continue-launch',
  grid: 'ad-creative-batch-grid',
  card: (id: string) => `ad-creative-batch-card-${id}`,
  cardStatus: (id: string) => `ad-creative-batch-card-status-${id}`,
  /** FR10-I3: pre-filled spec completeness chip (ready / forming / needs_attention). */
  cardSpec: (id: string) => `ad-creative-batch-card-spec-${id}`,
  cardWinner: (id: string) => `ad-creative-batch-card-winner-${id}`,
  cardVideoCta: (id: string) => `ad-creative-batch-card-video-cta-${id}`,
  // FR1 click zones: media = inspect (lightbox), footer = details (drawer),
  // ▶ = inline playback, 🔍 = explicit inspect, Retry on failed cards.
  cardMedia: (id: string) => `ad-creative-batch-card-media-${id}`,
  cardFooter: (id: string) => `ad-creative-batch-card-footer-${id}`,
  cardZoom: (id: string) => `ad-creative-batch-card-zoom-${id}`,
  cardPlay: (id: string) => `ad-creative-batch-card-play-${id}`,
  cardRetry: (id: string) => `ad-creative-batch-card-retry-${id}`,
  cardPhase: (id: string) => `ad-creative-batch-card-phase-${id}`,
  filterFormat: 'ad-creative-batch-filter-format',
  filterAngle: 'ad-creative-batch-filter-angle',
  drawer: 'ad-creative-batch-drawer',
  drawerClose: 'ad-creative-batch-drawer-close',
  drawerPreview: 'ad-creative-batch-drawer-preview',
  drawerLocales: 'ad-creative-batch-drawer-locales',
  drawerLocaleSelect: 'ad-creative-batch-drawer-locale-select',
  drawerLocaleStatus: 'ad-creative-batch-drawer-locale-status',
  drawerLocaleConfigRequired: 'ad-creative-batch-drawer-locale-config-required',
  drawerAddLocale: 'ad-creative-batch-drawer-add-locale',
  drawerArchiveLocale: 'ad-creative-batch-drawer-archive-locale',
  drawerCompareLocale: 'ad-creative-batch-drawer-compare-locale',
  drawerNewLocaleSelect: 'ad-creative-batch-drawer-new-locale-select',
  drawerConfirmAddLocale: 'ad-creative-batch-drawer-confirm-add-locale',
  drawerMakeDefaultLocale: 'ad-creative-batch-drawer-make-default-locale',
  drawerDefaultLocaleConfirmation: 'ad-creative-batch-drawer-default-locale-confirmation',
  drawerConfirmDefaultLocale: 'ad-creative-batch-drawer-confirm-default-locale',
  drawerCancelDefaultLocale: 'ad-creative-batch-drawer-cancel-default-locale',
  drawerDefaultLocaleIncomplete: 'ad-creative-batch-drawer-default-locale-incomplete',
  drawerDefaultLocaleStaleExplanation: 'ad-creative-batch-drawer-default-locale-stale-explanation',
  drawerFallbackToggle: 'ad-creative-batch-drawer-fallback-toggle',
  drawerFallbackNotice: 'ad-creative-batch-drawer-fallback-notice',
  drawerSourceField: (key: string) => `ad-creative-batch-drawer-source-${key}`,
  drawerSourceEditWarning: 'ad-creative-batch-drawer-source-edit-warning',
  drawerApproveLocale: 'ad-creative-batch-drawer-approve-locale',
  drawerComponentReview: 'ad-creative-batch-drawer-component-review',
  drawerComponentReviewNotes: 'ad-creative-batch-drawer-component-review-notes',
  drawerComponentReviewRow: (component: string) => `ad-creative-batch-drawer-component-review-${component}`,
  drawerComponentAccept: (component: string) => `ad-creative-batch-drawer-component-accept-${component}`,
  drawerComponentRequestChanges: (component: string) => `ad-creative-batch-drawer-component-request-changes-${component}`,
  drawerComponentReject: (component: string) => `ad-creative-batch-drawer-component-reject-${component}`,
  drawerComponentRegenerate: (component: string) => `ad-creative-batch-drawer-component-regenerate-${component}`,
  drawerMediaSection: 'ad-creative-batch-drawer-media-section',
  drawerMediaSlot: (slotKey: string) => `ad-creative-batch-drawer-media-slot-${slotKey}`,
  drawerMediaState: (slotKey: string) => `ad-creative-batch-drawer-media-state-${slotKey}`,
  drawerMediaPreview: (slotKey: string) => `ad-creative-batch-drawer-media-preview-${slotKey}`,
  drawerMediaReuse: (slotKey: string) => `ad-creative-batch-drawer-media-reuse-${slotKey}`,
  drawerMediaReuseAll: (slotKey: string) => `ad-creative-batch-drawer-media-reuse-all-${slotKey}`,
  drawerMediaUpload: (slotKey: string) => `ad-creative-batch-drawer-media-upload-${slotKey}`,
  drawerMediaFileInput: (slotKey: string) => `ad-creative-batch-drawer-media-file-${slotKey}`,
  drawerMediaEvidence: (slotKey: string) => `ad-creative-batch-drawer-media-evidence-${slotKey}`,
  drawerMediaDisable: (slotKey: string) => `ad-creative-batch-drawer-media-disable-${slotKey}`,
  drawerMediaProgress: (slotKey: string) => `ad-creative-batch-drawer-media-progress-${slotKey}`,
  drawerDestinationSection: 'ad-creative-batch-drawer-destination-section',
  drawerDestinationState: 'ad-creative-batch-drawer-destination-state',
  drawerDestinationModeFunnel: 'ad-creative-batch-drawer-destination-mode-funnel',
  drawerDestinationModeArticle: 'ad-creative-batch-drawer-destination-mode-article',
  drawerDestinationModeUrl: 'ad-creative-batch-drawer-destination-mode-url',
  drawerDestinationModeNone: 'ad-creative-batch-drawer-destination-mode-none',
  drawerDestinationUrl: 'ad-creative-batch-drawer-destination-url',
  drawerDestinationReference: 'ad-creative-batch-drawer-destination-reference',
  drawerDestinationOption: (kind: string, id: string) => `ad-creative-batch-drawer-destination-option-${kind}-${id}`,
  drawerDestinationEvidence: 'ad-creative-batch-drawer-destination-evidence',
  drawerDestinationSuggestions: 'ad-creative-batch-drawer-destination-suggestions',
  drawerDestinationFallbackApproval: 'ad-creative-batch-drawer-destination-fallback-approval',
  drawerDestinationCatalogError: 'ad-creative-batch-drawer-destination-catalog-error',
  drawerDestinationSave: 'ad-creative-batch-drawer-destination-save',
  drawerCopyField: (key: string) => `ad-creative-batch-drawer-copy-${key}`,
  drawerSaveCopy: 'ad-creative-batch-drawer-save-copy',
  drawerValidate: 'ad-creative-batch-drawer-validate',
  drawerValidationChip: (id: string) => `ad-creative-batch-drawer-validation-${id}`,
  drawerRegenerateImage: 'ad-creative-batch-drawer-regenerate-image',
  drawerVariateCopy: 'ad-creative-batch-drawer-variate-copy',
  drawerMakeVideo: 'ad-creative-batch-drawer-make-video',
  drawerOpenStoryboard: 'ad-creative-batch-drawer-open-storyboard',
  drawerAiLocalization: 'ad-creative-batch-drawer-ai-localization',
  drawerAiComponent: (component: string) => `ad-creative-batch-drawer-ai-component-${component}`,
  drawerAiContext: 'ad-creative-batch-drawer-ai-context',
  drawerAiResourcesLoading: 'ad-creative-batch-drawer-ai-resources-loading',
  drawerAiResourcesError: 'ad-creative-batch-drawer-ai-resources-error',
  drawerAiResourcesRetry: 'ad-creative-batch-drawer-ai-resources-retry',
  drawerAiResourcesEmpty: 'ad-creative-batch-drawer-ai-resources-empty',
  drawerAiProfile: 'ad-creative-batch-drawer-ai-profile',
  drawerAiProfileSummary: 'ad-creative-batch-drawer-ai-profile-summary',
  drawerAiSavedGlossary: 'ad-creative-batch-drawer-ai-saved-glossary',
  drawerAiGlossarySummary: 'ad-creative-batch-drawer-ai-glossary-summary',
  drawerAiTargetMarket: 'ad-creative-batch-drawer-ai-target-market',
  drawerAiTone: 'ad-creative-batch-drawer-ai-tone',
  drawerAiMarketDirection: 'ad-creative-batch-drawer-ai-market-direction',
  drawerAiGlossary: 'ad-creative-batch-drawer-ai-glossary',
  drawerAiClaims: 'ad-creative-batch-drawer-ai-claims',
  drawerAiProtectedTokens: 'ad-creative-batch-drawer-ai-protected-tokens',
  drawerAiInstruction: 'ad-creative-batch-drawer-ai-instruction',
  drawerAiImageMode: 'ad-creative-batch-drawer-ai-image-mode',
  drawerAiImageInspect: 'ad-creative-batch-drawer-ai-image-inspect',
  drawerAiImageInspectionProgress: 'ad-creative-batch-drawer-ai-image-inspection-progress',
  drawerAiImageInspectionReady: 'ad-creative-batch-drawer-ai-image-inspection-ready',
  drawerAiImageTargetText: (slotKey: string) => `ad-creative-batch-drawer-ai-image-target-text-${slotKey}`,
  drawerAiVideoSlot: 'ad-creative-batch-drawer-ai-video-slot',
  drawerAiVideoCaptions: 'ad-creative-batch-drawer-ai-video-captions',
  drawerAiVideoVoiceToggle: 'ad-creative-batch-drawer-ai-video-voice-toggle',
  drawerAiVideoVoiceMode: 'ad-creative-batch-drawer-ai-video-voice-mode',
  drawerAiVideoOnScreenTextToggle: 'ad-creative-batch-drawer-ai-video-on-screen-text-toggle',
  drawerAiVideoCulturalVisualToggle: 'ad-creative-batch-drawer-ai-video-cultural-visual-toggle',
  drawerApprovedAudioPanel: 'ad-creative-batch-drawer-approved-audio-panel',
  drawerApprovedAudioUpload: 'ad-creative-batch-drawer-approved-audio-upload',
  drawerApprovedAudioLoadMore: 'ad-creative-batch-drawer-approved-audio-load-more',
  drawerApprovedAudioCard: (candidateId: string) => `ad-creative-batch-drawer-approved-audio-card-${candidateId}`,
  drawerApprovedAudioPlayback: (candidateId: string) => `ad-creative-batch-drawer-approved-audio-playback-${candidateId}`,
  drawerApprovedAudioConfirmation: (candidateId: string, confirmation: string) => `ad-creative-batch-drawer-approved-audio-confirmation-${candidateId}-${confirmation}`,
  drawerApprovedAudioApprove: (candidateId: string) => `ad-creative-batch-drawer-approved-audio-approve-${candidateId}`,
  drawerApprovedAudioReject: (candidateId: string) => `ad-creative-batch-drawer-approved-audio-reject-${candidateId}`,
  drawerApprovedAudioSelect: (candidateId: string) => `ad-creative-batch-drawer-approved-audio-select-${candidateId}`,
  drawerAiPreflight: 'ad-creative-batch-drawer-ai-preflight',
  drawerAiCapability: 'ad-creative-batch-drawer-ai-capability',
  drawerAiEstimate: 'ad-creative-batch-drawer-ai-estimate',
  drawerAiUnsupportedReason: (index: number) => `ad-creative-batch-drawer-ai-unsupported-${index}`,
  drawerAiConfirmation: 'ad-creative-batch-drawer-ai-confirmation',
  drawerAiStart: 'ad-creative-batch-drawer-ai-start',
  drawerAiProgress: 'ad-creative-batch-drawer-ai-progress',
  drawerAiStatus: 'ad-creative-batch-drawer-ai-status',
  drawerAiCancel: 'ad-creative-batch-drawer-ai-cancel',
  drawerAiResume: 'ad-creative-batch-drawer-ai-resume',
  drawerAiReviewRequired: 'ad-creative-batch-drawer-ai-review-required',
  drawerCaptionReviewLoad: 'ad-creative-batch-drawer-caption-review-load',
  drawerCaptionReviewPanel: 'ad-creative-batch-drawer-caption-review-panel',
  drawerCaptionReviewError: 'ad-creative-batch-drawer-caption-review-error',
  drawerVideoReviewPlayer: 'ad-creative-batch-drawer-video-review-player',
  drawerVideoReviewGate: 'ad-creative-batch-drawer-video-review-gate',
  drawerCaptionReviewSidecarLink: 'ad-creative-batch-drawer-caption-review-sidecar-link',
  drawerCaptionReviewCue: (index: number) => `ad-creative-batch-drawer-caption-review-cue-${index}`,
  drawerImageReviewPanel: 'ad-creative-batch-drawer-image-review-panel',
  drawerImageReviewLoading: 'ad-creative-batch-drawer-image-review-loading',
  drawerImageReviewError: 'ad-creative-batch-drawer-image-review-error',
  drawerImageReviewRetry: 'ad-creative-batch-drawer-image-review-retry',
  drawerImageReviewEmpty: 'ad-creative-batch-drawer-image-review-empty',
  drawerImageReviewStale: 'ad-creative-batch-drawer-image-review-stale',
  drawerImageReviewSlot: (slotKey: string) => `ad-creative-batch-drawer-image-review-slot-${slotKey}`,
  drawerImageReviewSource: (slotKey: string) => `ad-creative-batch-drawer-image-review-source-${slotKey}`,
  drawerImageReviewTarget: (slotKey: string) => `ad-creative-batch-drawer-image-review-target-${slotKey}`,
  drawerImageReviewTargetLoading: (slotKey: string) => `ad-creative-batch-drawer-image-review-target-loading-${slotKey}`,
  drawerImageReviewTargetError: (slotKey: string) => `ad-creative-batch-drawer-image-review-target-error-${slotKey}`,
  drawerImageReviewTargetRetry: (slotKey: string) => `ad-creative-batch-drawer-image-review-target-retry-${slotKey}`,
  drawerImageReviewCheck: (slotKey: string, check: string) => `ad-creative-batch-drawer-image-review-check-${slotKey}-${check}`,
  drawerImageReviewExpectedText: (slotKey: string) => `ad-creative-batch-drawer-image-review-expected-${slotKey}`,
  drawerImageReviewObservedText: (slotKey: string) => `ad-creative-batch-drawer-image-review-observed-${slotKey}`,
  drawerPromptAccordion: 'ad-creative-batch-drawer-prompt-accordion',
  drawerHistoryAccordion: 'ad-creative-batch-drawer-history-accordion',
  briefStep: 'ad-creative-batch-step-brief',
  anglesStep: 'ad-creative-batch-step-angles',
  anglesGenerate: 'ad-creative-batch-angles-generate',
  angleRow: (id: string) => `ad-creative-batch-angle-${id}`,
  creativesStep: 'ad-creative-batch-step-creatives',
  launchStep: 'ad-creative-batch-step-launch',
  research: 'ad-creative-batch-research',
  launchWinnersStrip: 'ad-creative-batch-launch-winners',
  launchWinnerName: (id: string) => `ad-creative-batch-launch-winner-name-${id}`,
  launchWinnerLocale: (id: string) => `ad-creative-batch-launch-winner-locale-${id}`,
  launchLocaleBlocker: 'ad-creative-batch-launch-locale-blocker',
  launchNamingTemplate: 'ad-creative-batch-launch-naming-template',
  launchSaveNaming: 'ad-creative-batch-launch-save-naming',
  launchLandingUrl: 'ad-creative-batch-launch-landing-url',
  launchUtmPreview: 'ad-creative-batch-launch-utm-preview',
  launchAdAccount: 'ad-creative-batch-launch-ad-account',
  launchPage: 'ad-creative-batch-launch-page',
  launchCampaign: 'ad-creative-batch-launch-campaign',
  launchAdSetMode: 'ad-creative-batch-launch-ad-set-mode',
  launchAdSet: 'ad-creative-batch-launch-ad-set',
  launchNewAdSetName: 'ad-creative-batch-launch-new-ad-set-name',
  launchSubmit: 'ad-creative-batch-launch-submit',
  launchBulkSheet: 'ad-creative-batch-launch-bulk-sheet',
  launchResult: 'ad-creative-batch-launch-result',
} as const;

/** Insight-grounded context surfaces (insight-context rework, mocks 01-04). */
export const AD_CREATIVE_INSIGHT = {
  contextRow: 'ad-creative-insight-context-row',
  analysisSelect: 'ad-creative-insight-analysis-select',
  analysisOption: (id: string) => `ad-creative-insight-analysis-option-${id}`,
  chip: (key: string) => `ad-creative-insight-chip-${key}`,
  legend: 'ad-creative-insight-legend',
  rederive: 'ad-creative-insight-rederive',
  ungroundedStrip: 'ad-creative-insight-ungrounded-strip',
  ungroundedLink: 'ad-creative-insight-ungrounded-link',
  angleCite: (id: string) => `ad-creative-insight-angle-cite-${id}`,
  angleAudience: (id: string) => `ad-creative-insight-angle-audience-${id}`,
  coverageStrip: 'ad-creative-insight-coverage-strip',
  angleFromInsight: 'ad-creative-insight-angle-from-insight',
  dataSources: 'ad-creative-insight-data-sources',
  dataSourceRow: (index: number) => `ad-creative-insight-data-source-row-${index}`,
  claimChip: (slot: string) => `ad-creative-insight-claim-chip-${slot}`,
  claimSummary: 'ad-creative-insight-claim-summary',
  videoGroundedBanner: 'ad-creative-insight-video-grounded-banner',
  videoSceneHint: (index: number) => `ad-creative-insight-video-scene-hint-${index}`,
  // FR3 — thesis subset summary chip (display-only since the context dialog):
  subsetChip: 'ad-creative-insight-subset-chip',
  // Context dialog (strategy CompositeDataPicker mechanism) — selection
  // happens ONLY here; the row displays. Inner tree: `insights-picker-tree`
  // (rc-tree), tabs: `composite-picker-tabs` (data-pickers-owned testids).
  contextConfigure: 'ad-creative-insight-context-configure',
  contextDialog: 'ad-creative-insight-context-dialog',
  contextSources: 'ad-creative-insight-context-sources',
  // FR3 — angles seed checklist (mock 04):
  seedChecklist: 'ad-creative-insight-seed-checklist',
  seedRow: (id: string) => `ad-creative-insight-seed-row-${id}`,
  seedGenerate: 'ad-creative-insight-seed-generate',
  // FR3 — hybrid brief fields + proof pickers (mock 02):
  briefField: (key: string) => `ad-creative-insight-brief-field-${key}`,
  fieldFromInsights: (field: string) => `ad-creative-insight-field-menu-${field}`,
  fieldOption: (field: string, id: string) => `ad-creative-insight-field-option-${field}-${id}`,
  proofRow: 'ad-creative-insight-proof-row',
  proofChip: (id: string) => `ad-creative-insight-proof-chip-${id}`,
  proofAdd: 'ad-creative-insight-proof-add',
  proofOption: (id: string) => `ad-creative-insight-proof-option-${id}`,
} as const;

export const AD_CREATIVE_ADMIN = {
  page: 'ad-creative-admin-platforms-page',
  networkList: 'ad-creative-admin-network-list',
  network: (id: string) => `ad-creative-admin-network-${id}`,
  id: 'ad-creative-admin-network-id',
  displayName: 'ad-creative-admin-network-display-name',
  provider: 'ad-creative-admin-network-provider',
  status: 'ad-creative-admin-network-status',
  policySummary: 'ad-creative-admin-network-policy-summary',
  placements: 'ad-creative-admin-network-placements',
  active: 'ad-creative-admin-network-active',
  save: 'ad-creative-admin-network-save',
  refresh: 'ad-creative-admin-network-refresh',
  statusMessage: 'ad-creative-admin-status',
} as const;

/** FR1 — lightbox meta panel (CreativeMetaSummary) testids. */
export const AD_CREATIVE_LIGHTBOX = {
  metaRoot: 'ad-creative-lightbox-meta',
  metaTemplate: 'ad-creative-lightbox-meta-template',
  metaAngle: 'ad-creative-lightbox-meta-angle',
  metaClaimChip: (slot: string) => `ad-creative-lightbox-meta-claim-${slot}`,
  metaClaimSummary: 'ad-creative-lightbox-meta-claim-summary',
  metaSourceRow: (index: number) => `ad-creative-lightbox-meta-source-${index}`,
} as const;

/** Video Studio (drawer video controls; FR2 state machine ids included). */
export const AD_CREATIVE_VIDEO_STUDIO = {
  root: 'ad-creative-video-studio',
  duration: 'ad-creative-video-studio-duration',
  model: 'ad-creative-video-studio-model',
  generate: 'ad-creative-video-studio-generate',
  cost: 'ad-creative-video-studio-cost',
  sceneCard: (index: number) => `ad-creative-video-studio-scene-${index}`,
  sceneMotion: (index: number) => `ad-creative-video-studio-scene-motion-${index}`,
  sceneDuration: (index: number) => `ad-creative-video-studio-scene-duration-${index}`,
  sceneRegenerate: (index: number) => `ad-creative-video-studio-scene-regenerate-${index}`,
  sceneApply: (index: number) => `ad-creative-video-studio-scene-apply-${index}`,
  timeline: 'ad-creative-video-studio-timeline',
  timelineTotal: 'ad-creative-video-studio-timeline-total',
  player: 'ad-creative-video-studio-player',
  regenerateMenu: 'ad-creative-video-studio-regenerate',
  // FR2 — explicit state machine surfaces:
  idleCaption: 'ad-creative-video-studio-idle-caption',
  phaseChecklist: 'ad-creative-video-studio-phases',
  phaseRow: (key: string) => `ad-creative-video-studio-phase-${key}`,
  cancel: 'ad-creative-video-studio-cancel',
  lockCaption: 'ad-creative-video-studio-lock-caption',
  storyboardLink: 'ad-creative-video-studio-storyboard-link',
  retry: 'ad-creative-video-studio-retry',
} as const;

/** FR4 — generation settings popover + catalog formats testids. */
export const AD_CREATIVE_GEN_SETTINGS = {
  trigger: 'ad-creative-gen-settings-trigger',
  popover: 'ad-creative-gen-settings-popover',
  effort: 'ad-creative-gen-settings-effort',
  budget: 'ad-creative-gen-settings-budget',
  budgetPreset: (value: number) => `ad-creative-gen-settings-budget-${value}`,
  warning: 'ad-creative-gen-settings-warning',
  reset: 'ad-creative-gen-settings-reset',
} as const;

export const AD_CREATIVE_FORMATS = {
  networkSelect: 'ad-creative-network-select',
  networkOption: (id: string) => `ad-creative-network-option-${id}`,
  family: (family: string) => `ad-creative-format-family-${family}`,
  familyToggle: (family: string) => `ad-creative-format-family-toggle-${family}`,
  template: (id: string) => `ad-creative-format-template-${id}`,
  selectAll: 'ad-creative-format-select-all',
  matrixLine: 'ad-creative-format-matrix-line',
} as const;

/** FR8 — briefs review stage (briefs_first batches). */
export const AD_CREATIVE_BRIEFS = {
  stage: 'ad-creative-briefs-stage',
  generateAll: 'ad-creative-briefs-generate-all',
  counter: 'ad-creative-briefs-counter',
  briefsFirstButton: 'ad-creative-home-briefs-first',
  card: (id: string) => `ad-creative-briefs-card-${id}`,
  cardEdit: (id: string) => `ad-creative-briefs-card-edit-${id}`,
  cardGenerate: (id: string) => `ad-creative-briefs-card-generate-${id}`,
  cardConcept: (id: string) => `ad-creative-briefs-card-concept-${id}`,
  cardSave: (id: string) => `ad-creative-briefs-card-save-${id}`,
  cardCancel: (id: string) => `ad-creative-briefs-card-cancel-${id}`,
  cardWarning: (id: string) => `ad-creative-briefs-card-warning-${id}`,
  cardGenerated: (id: string) => `ad-creative-briefs-card-generated-${id}`,
  beatField: (id: string, index: number) => `ad-creative-briefs-beat-${id}-${index}`,
} as const;

/** FR7 — creative framework picker (Create home, per format family). */
export const AD_CREATIVE_FRAMEWORKS = {
  row: (family: string) => `ad-creative-framework-row-${family}`,
  add: (family: string) => `ad-creative-framework-add-${family}`,
  option: (id: string) => `ad-creative-framework-option-${id}`,
  chip: (id: string) => `ad-creative-framework-chip-${id}`,
  customField: 'ad-creative-framework-custom-field',
  customExclusive: 'ad-creative-framework-custom-exclusive',
} as const;

/** FR5 — storyboard workspace (brief · timeline · inspector · fullscreen · insert). */
export const AD_CREATIVE_STORYBOARD = {
  view: 'ad-creative-storyboard-view',
  backToBatch: 'ad-creative-storyboard-back',
  stageRail: 'ad-creative-storyboard-stage-rail',
  stage: (name: string) => `ad-creative-storyboard-stage-${name}`,
  briefBar: 'ad-creative-storyboard-brief-bar',
  briefBarExpand: 'ad-creative-storyboard-brief-bar-expand',
  briefFramework: 'ad-creative-storyboard-brief-framework',
  // FR8-I2: single-scene collapse (1-scene plans skip the timeline ceremony)
  singleScene: 'ad-creative-storyboard-single-scene',
  singleSceneRender: 'ad-creative-storyboard-single-scene-render',
  singleSceneTimeline: 'ad-creative-storyboard-single-scene-timeline',
  // Master player
  player: 'ad-creative-storyboard-player',
  playerMode: (mode: string) => `ad-creative-storyboard-player-mode-${mode}`,
  playerLightbox: 'ad-creative-storyboard-player-lightbox',
  // Timeline
  timeline: 'ad-creative-storyboard-timeline',
  timelineSegment: (index: number) => `ad-creative-storyboard-segment-${index}`,
  segmentStatus: (index: number) => `ad-creative-storyboard-segment-status-${index}`,
  segmentRetime: (index: number) => `ad-creative-storyboard-segment-retime-${index}`,
  insertHotspot: (index: number) => `ad-creative-storyboard-insert-${index}`,
  addScene: 'ad-creative-storyboard-add-scene',
  ruler: 'ad-creative-storyboard-ruler',
  // Inspector (selected scene)
  inspector: 'ad-creative-storyboard-inspector',
  inspectorPrompt: (kind: string) => `ad-creative-storyboard-inspector-prompt-${kind}`,
  inspectorEdit: (kind: string) => `ad-creative-storyboard-inspector-edit-${kind}`,
  inspectorThesis: 'ad-creative-storyboard-inspector-thesis',
  inspectorThesisChange: 'ad-creative-storyboard-inspector-thesis-change',
  inspectorAction: (name: string) => `ad-creative-storyboard-inspector-action-${name}`,
  inspectorTakes: 'ad-creative-storyboard-inspector-takes',
  inspectorDuration: 'ad-creative-storyboard-inspector-duration',
  staleBanner: 'ad-creative-storyboard-stale-banner',
  kfVersions: 'ad-creative-storyboard-kf-versions',
  kfVersion: (index: number) => `ad-creative-storyboard-kf-version-${index}`,
  kfAction: (name: string) => `ad-creative-storyboard-kf-action-${name}`,
  rewriteFromBrief: 'ad-creative-storyboard-rewrite-from-brief',
  applyAction: (name: string) => `ad-creative-storyboard-apply-${name}`,
  chainCard: 'ad-creative-storyboard-chain-card',
  renderRemaining: 'ad-creative-storyboard-render-remaining',
  allKeyframes: 'ad-creative-storyboard-all-keyframes',
  // Brief stage (mock 08)
  briefStage: 'ad-creative-storyboard-brief-stage',
  briefField: (name: string) => `ad-creative-storyboard-brief-field-${name}`,
  groundingPanel: 'ad-creative-storyboard-grounding',
  groundingRow: (role: string) => `ad-creative-storyboard-grounding-row-${role}`,
  briefInstruction: 'ad-creative-storyboard-brief-instruction',
  regenerateBrief: 'ad-creative-storyboard-regenerate-brief',
  approveBrief: 'ad-creative-storyboard-approve-brief',
  briefVersion: 'ad-creative-storyboard-brief-version',
  // Fullscreen scene (mock 13)
  fullscreen: 'ad-creative-storyboard-fullscreen',
  fsBack: 'ad-creative-storyboard-fs-back',
  fsNav: (direction: string) => `ad-creative-storyboard-fs-nav-${direction}`,
  fsPlayer: 'ad-creative-storyboard-fs-player',
  fsMiniTimeline: 'ad-creative-storyboard-fs-mini-timeline',
  fsMiniSegment: (index: number) => `ad-creative-storyboard-fs-mini-segment-${index}`,
  takesRail: 'ad-creative-storyboard-takes-rail',
  takeCard: (index: number) => `ad-creative-storyboard-take-${index}`,
  takeUse: (index: number) => `ad-creative-storyboard-take-use-${index}`,
  takeInUse: 'ad-creative-storyboard-take-in-use',
  takeMenu: (index: number) => `ad-creative-storyboard-take-menu-${index}`,
  newTakeReroll: 'ad-creative-storyboard-new-take-reroll',
  newTakeEditFirst: 'ad-creative-storyboard-new-take-edit-first',
  sceneSetup: 'ad-creative-storyboard-scene-setup',
  // Insert popover (mock 14)
  insertPopover: 'ad-creative-storyboard-insert-popover',
  insertRole: 'ad-creative-storyboard-insert-role',
  insertDuration: 'ad-creative-storyboard-insert-duration',
  insertThesis: 'ad-creative-storyboard-insert-thesis',
  insertDraft: 'ad-creative-storyboard-insert-draft',
  insertChainWarning: 'ad-creative-storyboard-insert-chain-warning',
  insertSlotCounter: 'ad-creative-storyboard-insert-slot-counter',
  insertConfirm: 'ad-creative-storyboard-insert-confirm',
  insertCancel: 'ad-creative-storyboard-insert-cancel',
} as const;
